import {Tooltip, Typography} from "@mui/material";
import {Colors} from "../../../components/Layout/Colors";
import {InfoOutlined, Warning} from "@mui/icons-material";
import React from "react";
import styled from "styled-components";
import {useTranslation} from "react-i18next";

const StyledSpan = styled.div`
    display: flex;
    align-items: center;
    .MuiTypography-root {
        padding-right: 7px;
    }
`;

export interface CustomerNameFieldProps {
    customerName: string;
    validationError: string | undefined;
    customerNameMismatch: boolean;
}
export const CustomerNameField = ({customerName, validationError, customerNameMismatch}: CustomerNameFieldProps) => {
    const {t} = useTranslation();
    const validationErrorDetected = validationError !== undefined && validationError?.length > 0;
    const errorState = customerNameMismatch || validationErrorDetected;
    const color: Colors | undefined = errorState ? Colors.RED : undefined;
    const errorTitle = validationErrorDetected ? t(validationError) : t("customerNameMismatching");
    const title = errorState ? errorTitle : customerName;

    return (
        <Tooltip
            title={title}
            placement="top"
            PopperProps={{
                sx: {
                    textAlign: "center",
                    maxWidth: "unset",
                },
            }}
        >
            <StyledSpan>
                {errorState && (validationError ? <Warning color={"warning"} /> : <InfoOutlined />)}
                <Typography color={color}>{customerName}</Typography>
            </StyledSpan>
        </Tooltip>
    );
};
